import {Injectable} from '@angular/core';

import {from, Observable} from 'rxjs';
import {AngularFireAuth} from '@angular/fire/auth';
import {catchError, filter, map, switchMap, take} from 'rxjs/operators';
import {UserInfo} from 'firebase';
import UserCredential = firebase.auth.UserCredential;

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  constructor(public afAuth: AngularFireAuth) {
  }
  get user() {
    console.log('getting auth user');
    return this.afAuth.authState;
  }


  public register(username: string, displayName: string, password: string) {
    let credential: UserCredential = null;
    return from(this.afAuth.auth.createUserWithEmailAndPassword(username, password)
      .then((cred: UserCredential) => {
        credential =   cred;
        return cred.user.updateProfile({displayName});
      })
      .then(() => {
        return credential.user;
      })
    );
  }

  public login(email: string, password: string): Observable<UserInfo | string> {
    return from(this.afAuth.auth.signInWithEmailAndPassword(email, password))
      .pipe(
        map((cred: UserCredential) => cred.user),
        catchError((error) => {
          console.log('error logging in', error);
          throw error;
        })
      );
  }

  public resetPassword(email: string): Observable<void> {
    return from(this.afAuth.auth.sendPasswordResetEmail(email));
  }

  public updateDisplayName( displayName: string) {
    return this.afAuth.authState.pipe(
      take(1),
      filter((user: firebase.User) => !!user),
      switchMap(( user ) => user.updateProfile({displayName}))
    );
  }

  public signOut(): Observable<void> {
    return from(this.afAuth.auth.signOut());
  }

  loadUser(): Observable<UserInfo> {
    return this.afAuth.authState.pipe(
      filter((authState) => authState !== null)
    );
  }
}
